import { useQueryClient } from "@tanstack/react-query";
import { useAuthTokens } from "modules/auth";

import useManagerAuthTokens from "./useManagerAuthTokens";

const useClearManagerSession = () => {
  const queryClient = useQueryClient();
  const { removeTokens: removeManagerTokens } = useManagerAuthTokens();
  const { removeTokens: removeUnifiedTokens } = useAuthTokens();

  return () => {
    queryClient.clear();
    removeManagerTokens();
    removeUnifiedTokens();
  };
};

export default useClearManagerSession;
